/*
 * ----------------------------------------------------------------------------
 * ZAHNHELD NEGATIVE CURSOR (sitewide)
 * ----------------------------------------------------------------------------
 * Instant dot plus a lerped trailing ring. The negative effect itself is pure
 * CSS (`mix-blend-mode: difference` in assets/zh-cursor.css); this file only
 * moves and scales the two divs.
 *
 * THE TWO HALVES SHARE ONE HOVER STATE
 * ------------------------------------
 * Only the position differs between dot and ring: the dot sits on the pointer,
 * the ring trails it. Everything the cursor reacts to, both halves react to on
 * the same easing — over anything clickable the ring swells to
 * RING_HOVER_SCALE while the dot shrinks to DOT_HOVER_SCALE and gets out of its
 * way. Do not give one of them an event the other ignores; that reads as a bug
 * rather than as a trailing ring.
 *
 * Both transforms are written inside the rAF frame rather than in the
 * pointermove handler. The dot is still instant — its position is never
 * interpolated, only its scale is — and it lands in the very next paint, while
 * several pointermove events inside one frame no longer each cost a style write.
 *
 * Deliberately standalone: no dependency on the vendored Motion engine, on
 * `html.zh-home-motion` or on the zh-motion-config toggle map, so the cursor
 * runs on every template while assets/zh-home-motion.* stay homepage-only.
 *
 * Companions: assets/zh-cursor.css, snippets/zh-cursor.liquid.
 * Tests: tests/zh-cursor.test.js.
 */
(function () {
  'use strict';

  var dot = document.getElementById('zh-cursor-dot');
  var ring = document.getElementById('zh-cursor-ring');

  // Absent when settings.zh_motion_cursor is off (the snippet renders nothing).
  if (!dot || !ring) return;

  // Coarse pointers have nothing to decorate, and reduced motion means no
  // trailing ring. CSS hides the divs in both cases; bailing here additionally
  // keeps the rAF loop from ever starting.
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERACTIVE = 'a[href], button, input, select, textarea, summary, [role="button"]';

  var RING_HOVER_SCALE = 1.9;
  var DOT_HOVER_SCALE = 0.5;
  var LERP_POSITION = 0.16; // ring position: this is the visible trailing
  var LERP_SCALE = 0.14; // ring and dot scale, deliberately the same for both

  var tx = -100; // pointer target
  var ty = -100;
  var cx = -100; // ring current position (lerped towards the target)
  var cy = -100;
  var ringTargetScale = 1;
  var ringScale = 1;
  var dotTargetScale = 1;
  var dotScale = 1;
  var running = false;

  var writeRing = function () {
    ring.style.transform =
      'translate3d(' + cx + 'px, ' + cy + 'px, 0) translate(-50%, -50%) scale(' + ringScale + ')';
  };

  var writeDot = function () {
    dot.style.transform =
      'translate3d(' + tx + 'px, ' + ty + 'px, 0) translate(-50%, -50%) scale(' + dotScale + ')';
  };

  var frame = function () {
    cx += (tx - cx) * LERP_POSITION;
    cy += (ty - cy) * LERP_POSITION;
    ringScale += (ringTargetScale - ringScale) * LERP_SCALE;
    dotScale += (dotTargetScale - dotScale) * LERP_SCALE;
    writeRing();
    writeDot();
    requestAnimationFrame(frame);
  };

  window.addEventListener(
    'pointermove',
    function (event) {
      tx = event.clientX;
      ty = event.clientY;
      if (dot.hidden) {
        // First move: seat both halves on the pointer and paint them there
        // BEFORE they become visible, so neither flies in from the top-left
        // corner, then spin up the loop.
        cx = tx;
        cy = ty;
        writeRing();
        writeDot();
        dot.hidden = false;
        ring.hidden = false;
        if (!running) {
          running = true;
          requestAnimationFrame(frame);
        }
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      var target = event.target;
      var interactive = !!(target && target.closest && target.closest(INTERACTIVE));
      ringTargetScale = interactive ? RING_HOVER_SCALE : 1;
      dotTargetScale = interactive ? DOT_HOVER_SCALE : 1;
    },
    { passive: true }
  );
})();
